export default __webpack_public_path__ + "locales/sr-Latn-RS/SocialAuthWelcomeDialog.json?hash=5abe765436baed9d2b2464dd069d5ac7";